module.exports = __webpack_public_path__ + "static/media/PhotoPreviewCard.9789b5ad.png";